import React, { useState, useEffect, useCallback } from "react";
import { Table, Typography, Select, Button, Result, Tooltip, Col, Row } from "antd";

import { riderLiveLocationServices } from "../../services/riderLiveLocation.service";
import { validationErrors } from "../../utils/Helpers";
import Pageloader from "../../components/loader";
import RiderMapBO from "./riderMapBO";
import * as zoneActions from "../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ReloadOutlined } from "@ant-design/icons";

const {Title} = Typography;
const { Option } = Select;
var _ = require('lodash');

const RiderLiveLocation = (props) => {
  const [loading, setLoading] = useState(false);
  const [postDataZone, setPostDataZone] = useState(null);
  const [postData, setPostData] = useState([]);
  const [postDataBO, setPostDataBO] = useState();
  const [postDataDisplay, setPostDataDisplay] = useState([]);
  const [iframeSrc, setIframeSrc] = useState([]);
  const [zone, setZone] = useState(null);
  const [filter, setFilter] = useState("all");
  
  useEffect(() => {
    postListsrefresh();
  }, []);
  useEffect(() => {
    if(postData){
      setPostDataDisplay(postData?.records);
      let loc = postData?.records?.map((location, index) => {
        if(location.lat && location.lon){
          let status_color = "";
          if(location.show_status == "Free") status_color = "#008000";
          else if(location.show_status == "Returning") status_color = "#800080";
          else if(location.show_status == "Assigned") status_color = "#FFA500";
          else if(location.show_status == "In Progress") status_color = "#FF0000";
          else if(location.show_status == "Break") status_color = "#0000FF";
          else if(location.show_status == "Offline") status_color = "#000";
          return location.lat+"::"+location.lon+"::"+location.rider_name+"::"+location.rider_display_id+"::"+location.phone_number+"::"+status_color;
        }
      }).filter(notUndefined => notUndefined !== undefined);
      let zone = postData?.zones?.startPoint.latitude+"::"+postData?.zones?.startPoint.longitude+"::"+encodeURIComponent(postData?.zones?.zoneName)+"::"+encodeURIComponent("#964B00");
      let center_lat, center_lon;
      if(loc && loc[0]) {
        center_lat = loc[0].split("::")[0]; 
        center_lon = loc[0].split("::")[1];
      }
      loc = encodeURIComponent(JSON.stringify(loc));
      if(postData?.returning != 0 || 
        postData?.free != 0 || 
        postData?.in_Progress != 0 || 
        postData?.break != 0 || 
        postData?.assigned != 0
      ) {
        setIframeSrc('<iframe src="'+process.env.REACT_APP_ROCKY_MAP_URL+'marker.html?z=16&center='+(center_lon ? center_lon : 67.06045001103925)+','+(center_lat ? center_lat : 24.872718203901023)+'&loc='+loc+'&zone='+zone+'&apikey='+process.env.REACT_APP_ROCKY_MAP_KEY+'" width="100%" height="450"></iframe>');
      } else { setIframeSrc(""); }
    }
  }, [postData]);
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.map((item, i) => {
        zoneData.push(<Option key={item.id}>{item.zoneName}</Option>);
      });
      setPostDataZone(zoneData);
    }
  }, [props.zoneData]);
  useEffect(() => {
    if(filter == "all"){
      setPostDataDisplay(postData?.records)
    } else if (filter == "returning") {
      // console.log(_.filter(postData?.records, function(v) { return v.show_status == "Returning"; }));
      setPostDataDisplay(_.filter(postData?.records, function(v) { return v.show_status == "Returning"; }))
    } else if (filter == "free") {
      // console.log(_.filter(postData?.records, function(v) { return v.show_status == "Free"; }));
      setPostDataDisplay(_.filter(postData?.records, function(v) { return v.show_status == "Free"; }))
    } else if (filter == "in_Progress") {
      // console.log(_.filter(postData?.records, function(v) { return v.show_status == "In Progress"; }));
      setPostDataDisplay(_.filter(postData?.records, function(v) { return v.show_status == "In Progress"; }))
    } else if (filter == "break") {
      // console.log(_.filter(postData?.records, function(v) { return v.show_status == "Break"; }));
      setPostDataDisplay(_.filter(postData?.records, function(v) { return v.show_status == "Break"; }))
    } else if (filter == "assigned") {
      // console.log(_.filter(postData?.records, function(v) { return v.show_status == "Assigned"; }));
      setPostDataDisplay(_.filter(postData?.records, function(v) { return v.show_status == "Assigned"; }))
    } else if (filter == "offline") {
      // console.log(_.filter(postData?.records, function(v) { return v.show_status == "Offline"; }));
      setPostDataDisplay(_.filter(postData?.records, function(v) { return v.show_status == "Offline"; }))
    }
  }, [filter]);

  
  const postListsrefresh = async () => {
    try {
      setLoading(true);
      await props.zoneActions.getZoneListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  };
  const handleChangeZone = useCallback (async (value) => {
    try {
      setLoading(true);
      setZone(value);
      const {data} = await riderLiveLocationServices(value);
      setIframeSrc("")
      setPostData(data.data)
      // setPostDataBO(bo)
    } catch(e) {
      validationErrors(e)
    } finally {
      setLoading(false);
    }
  });
  const getAttrs = (iframeTag) => {
    if(iframeTag){
      var doc = document.createElement('div');
      doc.innerHTML = iframeTag;
      const iframe = doc.getElementsByTagName('iframe')[0];
      return [].slice
        .call(iframe.attributes)
        .reduce((attrs, element) => {
          attrs[element.name] = element.value;
          return attrs;
        }, {});
    }
  } 
  const reloadMap = () => {
    handleChangeZone(zone)
  }
  
  const columns = [
    {
      title: 'Id',
      dataIndex: 'rider_display_id',
      key: 'rider_display_id',
    },
    {
      title: 'Name',
      dataIndex: 'rider_name',
      key: 'rider_name',
    },
    {
      title: 'Status',
      dataIndex: 'show_status',
      key: 'show_status',
    },
    {
      title: 'Cell No',
      dataIndex: 'phone_number',
      key: 'phone_number',
    },
  ];

  // let bo = {
  //   driverCount:5,
  //   title: "Driver",
  //   color: "#000",
  //   driverDetail: [
  //     {
  //       driverCount:1,
  //       title: "Returning",
  //       color: "#ffc62b",
  //     },
  //     {
  //       driverCount:1,
  //       title: "free",
  //       color: "#c3ce78",
  //     },
  //     {
  //       driverCount:3,
  //       title: "In Progress",
  //       color: "#38acc8",
  //     },
  //     {
  //       driverCount:0,
  //       title: "Break",
  //       color: "#9fadb6",
  //     },
  //     {
  //       driverCount:0,
  //       title: "Assigned",
  //       color: "#43b68b",
  //     },
  //     {
  //       driverCount:0,
  //       title: "Delayed",
  //       color: "#f5936d",
  //     },
  //     {
  //       driverCount:23,
  //       title: "Offline",
  //       color: "#eea94a",
  //     },
  //   ]
  // }

  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>Rider Live Location</Title>
        </div>
        <div className="pch">
          <Tooltip title="Refresh">
            <Button
              icon={<ReloadOutlined />}
              loading={loading}
              disabled={loading || !zone}
              onClick={() => reloadMap()}
            />
          </Tooltip>
          <Select
              showSearch
              filterOption={(input, option) =>  
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 
                || option.props.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Zone"
              onChange={handleChangeZone}
              style={{ minWidth: 300,}}
            >
              {postDataZone}
            </Select>
        </div>
      </div>
      <div className="p-content">
        {loading ? <Pageloader/> :
          postData && postData.length === 0 ?
            "Select Zone First"
          :
            <div className="rl-location">
              <RiderMapBO iframeTag={<iframe {...getAttrs(iframeSrc) } width="100%" height="450px" />} bo={postDataBO} postData={postData} setFilter={setFilter} />
              <Table dataSource={postDataDisplay} columns={columns} />
            </div>
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(RiderLiveLocation);
